// This is the code responsible for filling the grid with data.

import constants from "../../config/constants";

const $inject = ['$routeParams', 'dataService', 'dataSourceService'];

const lbaViewGridCtrl = function ($routeParams, dataService, dataSourceService) {
  const vm = this;
  vm.dataService = dataService;
  vm.ready = false;
  vm.canAdd = false;
  vm.filters = '';
  vm.blurLog = blurLog;
  vm.getLogs = getLogs;
  vm.selectItem = selectItem;
  vm.getObjectPropertyValue = getObjectPropertyValue;
  vm.clearFilter = clearFilter;
  let page = 1;

  if (dataService.backViewGridFilter != null && dataService.backViewGridFilter[vm.settings.displayName]) {
    vm.filters = dataService.backViewGridFilter[vm.settings.displayName]
  }

  if (dataService.backViewGridPage != null && dataService.backViewGridPage[vm.settings.displayName]) {
    page = dataService.backViewGridPage[vm.settings.displayName]
  }

  // go to the Lightning Config Api to get the data
  if (vm.settings.endpoint) {
    dataSourceService.dataSource = constants.DATA_SOURCES.ODATA;
    dataService.data.activeItem = undefined;
    getLogs();
  } else {
    const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
    const rowData = prepData(_.get(dataService.data.activeItem, dataLookUp));
    populateGrid(rowData);
  }
  
  function blurLog() {
    dataService.data.activeItem = null;
  }

  function getLogs() {
    vm.ready = false;
    const ODataArgs = vm.settings.ODataArgs || '';
    dataService.get(vm.settings.endpoint + ODataArgs).then((data) => {
      vm.dataService.data.logs = data;
      populateGrid(data);
    });
  }

  function populateGrid(rowData) {
    vm.resource = {
      header: vm.settings.gridCols,
      rows: rowData,
      pagination: {
        page
      }
    };

    vm.ready = true;
  }

  function selectItem(logMessage) {    
    dataService.data.activeItem = logMessage;
  }

  function prepData(data) {
    if (data) {
      return data.map(item => {
        return item;
      })
    }
  }

  function getObjectPropertyValue(obj, path, defaultValue = null) {
    return _.get(obj, path, defaultValue);
  }

  function clearFilter() {
    vm.filters = '';
  }
};


lbaViewGridCtrl.$inject = $inject;

export default lbaViewGridCtrl;



// WEBPACK FOOTER //
// ./src/components/lbaViewGrid/lbaViewGridCtrl.js